import { createSlice } from '@reduxjs/toolkit';
import MerchantMetricsService from '../../services/merchantMetrics';
import moment from 'moment';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  metrics: [],
  lastUpdated: null
};

const slice = createSlice({
  name: 'merchantMetrics',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET METRICS SUCCESS
    getMetricsSuccess(state, action) {
      state.isLoading = false;
      state.metrics = action.payload || [];
      state.lastUpdated = new Date().toISOString();
      state.error = false;
    },

    // CLEAR METRICS
    clearMetrics(state) {
      state.metrics = [];
      state.lastUpdated = null;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  getMetricsSuccess,
  clearMetrics
} = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
export function getMerchantMetrics() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // 1️⃣ Get start of local today
      const startOfUtcDay = moment.utc().startOf('day').toISOString();


      // 3️⃣ Call service with `at` filter
      const response = await MerchantMetricsService.getMetrics(startOfUtcDay);

      if (response.success) {
        dispatch(slice.actions.getMetricsSuccess(response.data));
      } else {
        dispatch(
          slice.actions.hasError(
            response.errors?.[0]?.message || 'Failed to fetch metrics'
          )
        );
      }
    } catch (error) {
      console.error('Error fetching merchant metrics:', error);
      dispatch(
        slice.actions.hasError(error.message || 'Failed to fetch metrics')
      );
    }
  };
}

